import { waitForElement } from "./waitForElement";
import { findElement } from "./findElement";

export const waitForButton = async (buttonId: string): Promise<boolean> => {
  const isReady = await waitForElement(buttonId, false);
  if (!isReady) return false;
  const relevantButton = findElement(buttonId);
  if (relevantButton) {
    relevantButton.click();
  }
  return isReady;
};
